import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isUIService} from '@github-ui/runtime-environment'

/** Whether the React code-view sidebar is active (always true in UI service, feature-flagged elsewhere). */
export function isReactCodeViewSidebarEnabled(): boolean {
  return isUIService || isFeatureEnabled('react_data_router_code_view_sidebar')
}
